export const TYPES = {
    CLUB_FUNCTION: 'Club Functions',
    EXPERIENCES: 'Experiences',
    AFL: 'AFL',
    CRICKET: 'Cricket',
    CONCERTS: 'Concerts',
    ASM: 'ASM',
};
